<template>
    <div class="advertisements-wrapper" v-if="doctor && doctor.isCertified && doctor.onboardingStep >= 5">
        <div class="advertisement" v-if="advertisements.length">
            <a :href="advertisements[currentKey].items[languageId].url" target="_blank" @click="dispatchAnalyticsEvent('Click')">
                <img :src="advertisements[currentKey].items[languageId].image" style="max-width: 100%">
            </a>
        </div>
    </div>
</template>

<script>
import helpers from '@/mixins/helpers'

import doctorAdvertisementRepository from '@/data/DoctorAdvertisementRepository'

export default {
    mixins: [helpers],

    data () {
        return {
            advertisements: [],
            currentKey: 0,
            timer: null,
            languageId: null
        }
    },

    mounted () {
        if (this.doctor) {
            this.languageId = _.find(this.languages, {code: this.doctor.language}).id
        } else {
            this.languageId = _.find(this.languages, {code: 'en'}).id
        }

        this.refresh()
    },

    beforeDestroy () {
        clearTimeout(this.timer)

        this.timer = null
    },

    methods: {
        refresh() {
            clearTimeout(this.timer)

            this.setLoading(true)

            doctorAdvertisementRepository.allForDoctor(this.doctor, (advertisements) => {
                this.advertisements = _.sortBy(_.filter(advertisements, (advertisement) => {
                    if (advertisement.isPublished && advertisement.hasOwnProperty('items') && advertisement.items.hasOwnProperty(this.languageId)) {
                        let item = advertisement.items[this.languageId]

                        return item.url && item.image
                    }

                    return false
                }), 'position')

                this.currentKey = Math.floor(Math.random() * (this.advertisements.length - 1))

                this.dispatchAnalyticsEvent('View')

                if (this.advertisements.length > 1) {
                    this.timer = this.rotate()
                }

                this.setLoading(false)
            })
        },

        rotate () {
            if (this.advertisements.length <= 0)
                return false

            if (this.currentKey == (this.advertisements.length - 1)) {
                this.currentKey = 0
            } else {
                this.currentKey++
            }

            this.dispatchAnalyticsEvent('View')

            this.timer = setTimeout(this.rotate, 30000)
        },

        dispatchAnalyticsEvent (action = 'View') {
            if (this.advertisements[this.currentKey]) {
                let event = {
                    eventCategory: 'DoctorAdvertisement',
                    eventAction: action,
                    // eventLabel: 'doctorAdvertisement.id',
                    eventLabel: this.advertisements[this.currentKey].id
                }

                this.$ga.event(event)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Doctor/Advertisements.vue